import { ComponentStyleConfig } from '@chakra-ui/react';
import { cssVar } from '@chakra-ui/theme-tools';

const $size = cssVar('spinner-size');

export const Spinner: ComponentStyleConfig = {
  baseStyle: {
    color: 'B.0',
    borderBottomColor: 'M.30',
    borderLeftColor: 'M.30',
  },
  sizes: {
    sm: {
      [$size.variable]: 'sizes.5',
    },
    md: {
      [$size.variable]: 'sizes.6',
    },
    lg: {
      [$size.variable]: 'sizes.9',
    },
    xl: {
      [$size.variable]: 'sizes.20',
    },
  },
  defaultProps: {
    size: 'sm',
  },
};
